import { Button, Flex, Icon, Menu, MenuButton, MenuItem, MenuList, Text } from '@chakra-ui/react'
import React from 'react'
import { RiLogoutBoxRLine, RiUserFill } from 'react-icons/ri'
import { useDispatch } from 'react-redux'
import { logoutUserAction } from '../../../modules/auth/Actions'
// import { logoutUserAction } from '../../modules/auth/Actions'

const LogoutMenu = ({ compact = false }) => {
    const dispatch = useDispatch()
    return (
        <Menu closeOnSelect={false}>
            <MenuButton
                bg='transparent'
                borderRadius='full'
                as={Button}
                p='0'
                _hover={{ bg: 'transparent' }}
                _focus={{ outline: 'none', bg: 'transparent' }}
                _active={{ outline: 'none', bg: 'transparent' }}>
                <Flex
                    borderRadius='full'
                    border='2px solid'
                    borderColor='#6A1E1E'
                    w={compact ? '44px' : '52px'}
                    h={compact ? '44px' : '42px'}
                    bg='rgba(255,255,255,0.95)'
                    alignItems='center'
                    justifyContent='center'
                    boxShadow={compact ? 'sm' : undefined}
                >
                    <Icon as={RiUserFill} color='#6A1E1E' fontSize={compact ? '22px' : '30px'} />
                </Flex>
            </MenuButton>
            <MenuList borderRadius="12px" borderColor="#D8CEC3" py={2} zIndex={2000}>
                <MenuItem
                  borderRadius="8px"
                  mx={1}
                  onClick={() => dispatch(logoutUserAction())}
                >
                    <Flex align="center" gap={2}>
                        <Icon as={RiLogoutBoxRLine} fontSize="18px" color="#4A0F1F" />
                        <Text fontWeight="600" color="#4A0F1F">Logout</Text>
                    </Flex>
                </MenuItem>
            </MenuList>
        </Menu >
    )
}

export default LogoutMenu